import { useState, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

/** Same admin fields as Firestore rules `isAdmin()` (role, type, or accountType). */
function profileIsAdmin(profile) {
  if (!profile || typeof profile !== "object") return false;
  return (
    profile.role === "admin" ||
    profile.type === "admin" ||
    profile.accountType === "admin"
  );
}

export default function AdminRoute() {
  const [state, setState] = useState({ user: undefined, profile: null, loading: true });
  const location = useLocation();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (nextUser) => {
      if (!nextUser) {
        setState({ user: null, profile: null, loading: false });
        return;
      }
      const profileSnap = await getDoc(doc(db, "users", nextUser.uid));
      setState({
        user: nextUser,
        profile: profileSnap.exists() ? profileSnap.data() : null,
        loading: false,
      });
    });
    return () => unsub();
  }, []);

  if (state.loading) return null;
  if (!state.user) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  const isAdmin =
    profileIsAdmin(state.profile) ||
    state.user?.role === "admin";
  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
